// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_AT_RULE_IMPORT_0___ from "-!../../../node_modules/css-loader/dist/cjs.js!../../css/App.css";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_AT_RULE_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.skitterbook-live-print-page-margin-container .expander-title {
    margin-left: 0.5rem;
}

.live-print-margin-inner {
    width: fit-content;
    display: flex;
    flex-direction: column;
}

    .live-print-margin-inner > span {
        width: 35rem;
        max-width: 75vw;
    }

.lpmi-title {
    font-weight: bold;
    margin-bottom: 0.5rem;
}

.front-side-margin, .back-side-margin > span {
    font-size: 14pt;
    margin: 1rem 0rem 2rem 0rem;
    text-decoration: underline;
}

.lpmi-profile {
    margin-top: 0.5rem;
    margin-bottom: 0.5rem;
}

.lpmi-profile-container > button {
    margin-left: 0.5rem;
}
`, "",{"version":3,"sources":["webpack://./src/Skitterbook/css/SkitterBookLivePrintPageMargin.css"],"names":[],"mappings":"AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,kBAAkB;IAClB,aAAa;IACb,sBAAsB;AAC1B;;IAEI;QACI,YAAY;QACZ,eAAe;IACnB;;AAEJ;IACI,iBAAiB;IACjB,qBAAqB;AACzB;;AAEA;IACI,eAAe;IACf,2BAA2B;IAC3B,0BAA0B;AAC9B;;AAEA;IACI,kBAAkB;IAClB,qBAAqB;AACzB;;AAEA;IACI,mBAAmB;AACvB","sourcesContent":["@import '../../css/App.css';\r\n\r\n.skitterbook-live-print-page-margin-container .expander-title {\r\n    margin-left: 0.5rem;\r\n}\r\n\r\n.live-print-margin-inner {\r\n    width: fit-content;\r\n    display: flex;\r\n    flex-direction: column;\r\n}\r\n\r\n    .live-print-margin-inner > span {\r\n        width: 35rem;\r\n        max-width: 75vw;\r\n    }\r\n\r\n.lpmi-title {\r\n    font-weight: bold;\r\n    margin-bottom: 0.5rem;\r\n}\r\n\r\n.front-side-margin, .back-side-margin > span {\r\n    font-size: 14pt;\r\n    margin: 1rem 0rem 2rem 0rem;\r\n    text-decoration: underline;\r\n}\r\n\r\n.lpmi-profile {\r\n    margin-top: 0.5rem;\r\n    margin-bottom: 0.5rem;\r\n}\r\n\r\n.lpmi-profile-container > button {\r\n    margin-left: 0.5rem;\r\n}\r\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
